/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_New_Offline_NoticeInputs */



/**
* | output |
* | --- |
* | "You're offline: the tournament is created and locked on this device, then uploaded when you reconnect." |
*
* @param {Tournament_New_Offline_NoticeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_new_offline_notice = /** @type {((inputs?: Tournament_New_Offline_NoticeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_New_Offline_NoticeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous êtes hors ligne : le tournoi est créé et verrouillé sur cet appareil, puis envoyé au serveur à la reconnexion.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Está sin conexión: el torneo se crea y se bloquea en este dispositivo, y se sube al servidor al reconectarse.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você está offline: o torneio é criado e bloqueado neste dispositivo, e enviado ao servidor quando você reconectar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Offline: il torneo viene creato e bloccato su questo dispositivo, poi inviato al server alla riconnessione.")
	return /** @type {LocalizedString} */ ("You're offline: the tournament is created and locked on this device, then uploaded when you reconnect.")
});